import { createRoot } from 'react-dom/client';
import { isShopifyThemeEditor } from '../../common/pageData';
import { fetchOfferData } from './api';
import React from 'react';
import { CSVUpload } from 'mrca-components';
import { createEmebeddedContainerWrapper } from '../../common/html';
import { GlobalStyle } from '../../globalStyle';
import { BaseURL } from '../../config';

export const checkAndDisplayCSVUpload = async ({ retryContainerCreation }) => {
  try {
    const offerData = await fetchOfferData();

    if (!offerData.isEligible) return null;
    const { isEligible, display, csvUploadFormat } = offerData;
    const { selector, position } = display;

    displayCSVUpload({
      isEligible,
      selector,
      position,
      csvUploadFormat,
      retryContainerCreation,
      offerData,
    });
  } catch (error) {
    console.error(error);
  }
};

const displayCSVUpload = async ({
  isEligible,
  selector,
  position,
  csvUploadFormat,
  retryContainerCreation,
  offerData,
}) => {
  const containers = [
    {
      selector,
      position,
      containerID: getCSVUploadContainerID(),
    },
  ];

  // if offer is not eligible then don't render
  if (!isEligible) {
    for (let i = 0; i < containers.length; i += 1) {
      const { containerID } = containers[i];
      renderCSVUploadInDiv({ close: true, containerID, offerData });
    }
    return;
  }

  const tasks: Promise<boolean>[] = [];
  for (let i = 0; i < containers.length; i += 1) {
    const { containerID, selector, position } = containers[i];
    tasks.push(
      createContainerAndRender({
        containerID,
        selector,
        position,
        retryContainerCreation,
        offerData,
        csvUploadFormat,
      }),
    );
  }
};

const createContainerAndRender = async ({
  containerID,
  selector,
  position,
  retryContainerCreation,
  offerData,
  csvUploadFormat,
}) => {
  const existing = document.getElementById(containerID);
  if (existing) {
    renderCSVUploadInDiv({
      containerID,
      offerData,
    });
    return true;
  }

  const selectors = selector.split(',');
  const positions = position.split(',');
  let container;
  for (let i = 0; i < selectors.length; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    container = await createEmebeddedContainerWrapper({
      id: containerID,
      selector: selectors[i].trim(),
      position: positions[i],
      retryContainerCreation,
      csvUploadFormat,
    });

    if (container) {
      break;
    }
  }

  if (container) {
    renderCSVUploadInDiv({
      containerID,
      offerData,
    });
    return true;
  }
  return false;
};

const renderCSVUploadInDiv = ({ close = false, containerID, offerData }) => {
  const container = document.getElementById(containerID);
  if (!container) {
    return;
  }
  container.style.width = '100%';

  let appBlockElement = document.querySelector(
    "[data-block-handle='embedded-csv-upload-header-button']",
  );

  // Test before changing or adding another logic -> long-money-plus.myshopify.com/
  if (!appBlockElement) {
    appBlockElement = document.querySelector(
      '[id^=shopify-block-upro_embedded_csv_upload_header_button]',
    );
  }

  if (appBlockElement && appBlockElement['style']) {
    // appBlockElement['style'].width = '100%';
    appBlockElement['style'].maxWidth = '100%';
    appBlockElement['style'].maxHeight = '100%';
    appBlockElement['style'].display = 'flex';
    appBlockElement['style'].alignItems = 'center';
  }

  if (isShopifyThemeEditor()) {
    return;
  }

  const root = createRoot(container);

  root.render(
    <>
      {!close && (
        <>
          <GlobalStyle />
          <CSVUpload defaultOfferData={offerData} baseUrl={BaseURL} />
        </>
      )}
    </>,
  );
};

const getCSVUploadContainerID = () => {
  // as the ids were predefined and old stores have this id, we cannot change it
  const trigger = 'sf';
  const offer = 'csvupload';

  return `mrca-div-embedded-${trigger}-${offer}`;
};
